module.exports = __webpack_public_path__ + "img/home-b1.2e99dec3.gif";